import { render, staticRenderFns } from "./MaterialsSearchDropdown.vue?vue&type=template&id=3982b1bc&"
import script from "./MaterialsSearchDropdown.vue?vue&type=script&lang=js&"
export * from "./MaterialsSearchDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports